import { Link } from "react-router-dom"
import IconPlus from '../icons/IconPlus'

const AddCard = (props) => {
    return (
        <Link to={props.link} className="bg-lavender-8 rounded-2xl min-h-[205px] basis-[278px] flex items-center justify-center">
            <div>
                <IconPlus />
            </div>
        </Link>
    )
}

export default AddCard